import {captureMessage} from '@sentry/browser';
import {showNotification} from 'platform/components';

/**
 * Handles unhandled data grid actions by either showing a notification in development mode or
 * capturing an error message in production mode.
 */
export const catchUnhandledDataGridActions = (actionKey: string) => {
  const isDev = process.env.ENV_TYPE === 'dev';

  if (isDev) {
    return showNotification.error(`Action callback was not specified for action ${actionKey}`);
  }

  captureMessage('unhandledDataGridAction', (scope) =>
    scope.setLevel('error').setExtras({
      userDescription: `Action callback was not specified for action ${actionKey}`,
    })
  );
};
